import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export const useArchivedActionGuard = (isArchived: boolean) => {
  const [isArchiveConfirmOpen, setIsArchiveConfirmOpen] = React.useState(false);
  const pendingArchiveActionRef = React.useRef<(() => void) | null>(null);

  const handleArchiveConfirm = () => {
    const action = pendingArchiveActionRef.current;
    pendingArchiveActionRef.current = null;
    setIsArchiveConfirmOpen(false);
    action?.();
  };

  const handleArchiveConfirmOpenChange = (open: boolean) => {
    if (!open) {
      pendingArchiveActionRef.current = null;
    }
    setIsArchiveConfirmOpen(open);
  };

  const guard = React.useCallback(
    (onConfirm: () => void) => {
      if (!isArchived) {
        onConfirm();
        return;
      }
      pendingArchiveActionRef.current = onConfirm;
      setIsArchiveConfirmOpen(true);
    },
    [isArchived],
  );

  const ArchiveConfirmDialog = (
    <AlertDialog
      open={isArchiveConfirmOpen}
      onOpenChange={handleArchiveConfirmOpenChange}
    >
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Sind Sie wirklich sicher?</AlertDialogTitle>
          <AlertDialogDescription>
            Sind Sie sicher? Der Vorgang wird damit automatisch reaktiviert und
            aus dem Archiv in die aktive Liste verschoben.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel>Abbrechen</AlertDialogCancel>
          <AlertDialogAction onClick={handleArchiveConfirm}>
            Fortfahren
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );

  return { guard, ArchiveConfirmDialog };
};
